import { AxiosInterceptor, TokenAxiosInterceptor } from "../interceptor/interceptor";

// 유저 정보 확인
export function getUser () {
    return TokenAxiosInterceptor({
        url: "/user/v1/users/me",
        method: "get"
    })
}

// 로그인
export function signin (data) {
    return AxiosInterceptor({
        url: "/user/v1/users/sign-in",
        method: "post",
        data
    })
}

// 로그아웃
export function signout () {
    return TokenAxiosInterceptor({
        url: "/user/v1/users/sign-out",
        method: "post",
    })
}

// 회원가입
export function signup (data) {
    return AxiosInterceptor({
        url: "/user/v1/users/sign-up",
        method: "post",
        data
    })
}

// 회원가입 이메일 인증 
export function verifyEmail (email) {
    return AxiosInterceptor({
        url: "/user/v1/users/email/verify",
        method: "post",
        data: {
            username: email
        }
    })
}

// 비밀번호 재설정 요청
export function requestResetPassword (email){
    return AxiosInterceptor({
        url: "/user/v1/users/password/reset/request",
        method: "post",
        data: {
            email
        }
    })
}

// 비밀번호 재설정 인증
export function verifyResetPassword (data){
    return AxiosInterceptor({
        url: "/user/v1/users/password/reset/verify",
        method: "post",
        data
    })
}

// 비밀번호 재설정
export function resetPassword (data) {
    return AxiosInterceptor({
        url: "/user/v1/users/password/reset",
        method: "put",
        data
    })
}